/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsServerNetworkUpload: {
  name: 'server-network-upload';
  data: string;
} = {
  name: 'server-network-upload',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7Zm0 2h10v10H7V4ZM3 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3Zm9-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm1-9.586V11a1 1 0 1 1-2 0V9.414l-.293.293a1 1 0 0 1-1.414-1.414l2-2a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1-1.414 1.414L13 9.414Z" fill="currentColor"/></svg>`,
};
